// Per-field settings an org admin keeps on a mapped NextGen document type
// (ENG-4052), as the Send to Chart editor applies them. The admin side lives in
// redesign/pages/NextgenFieldSettingsModal.jsx.

export const INTEGER_LIST = 'integer_list';
export const INTEGER_LIST_MESSAGE = 'Enter whole numbers separated by commas, like 1,2,12.';
const INTEGER_LIST_PATTERN = /^\s*\d+\s*(,\s*\d+\s*)*$/;

export const AI_SOURCE = 'ai';

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

// A real calendar date in YYYY-MM-DD: 2026-02-30 doesn't round-trip.
const isCalendarDate = (value) => {
  if (!DATE_PATTERN.test(String(value))) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
};

const sameId = (left, right) => String(left).toLowerCase() === String(right).toLowerCase();

// The rule's message for a value that breaks it, or null. An empty value is the
// required check's business, not the rule's. The server normalises spacing.
export const fieldRuleError = (field, value) => {
  if (field.validation !== INTEGER_LIST) return null;
  if (value === undefined || value === null || String(value).trim() === '') return null;
  return INTEGER_LIST_PATTERN.test(String(value)) ? null : INTEGER_LIST_MESSAGE;
};

// The values an AI suggestion fills, by field id: only for the type it was made
// for, and only values the field can hold (an offered pick-list option, a real
// date). Anything else is dropped rather than shown as a suggestion.
export const suggestedFieldValues = (documentType, suggestions) => {
  if (!documentType || !suggestions?.document_type_id || !sameId(suggestions.document_type_id, documentType.id)) {
    return {};
  }

  const fields = documentType.fields || [];
  return Object.fromEntries(Object.entries(suggestions.fields || {}).flatMap(([id, value]) => {
    const field = fields.find((candidate) => sameId(candidate.id, id));
    if (!field || value === undefined || value === null || value === '') return [];
    if (field.kind === 'pick_list') {
      const option = (field.options || []).find((candidate) => sameId(candidate.id, value));
      return option ? [[field.id, option.id]] : [];
    }
    if (field.kind === 'date') {
      return isCalendarDate(value) ? [[field.id, value]] : [];
    }
    return [];
  }));
};
